import BecaService from '@/entities/seguimiento/beca.service';
import AlertService from '@/shared/alert/alert.service';
import { FiltroBeca } from '@/shared/model/filtro.model';
import { BecaSeleccion, IBeca, IBecaSeleccion } from '@/shared/model/seguimiento/beca.model';
import { TipoSolucion } from '@conacyt/perfil-usuario-client';
import { BvTableFieldArray } from 'bootstrap-vue';
import { Component, Emit, Inject, Prop, Vue } from 'vue-property-decorator';

/**
 */
@Component
export default class BuscadorBEcariosComponent extends Vue {
  @Inject('alertService') private alertService!: () => AlertService;
  @Inject('becaService') private becaService!: () => BecaService;

  @Prop({
    required: false,
    default: false,
  })
  public esReadOnly!: boolean;

  @Prop({
    required: true,
  })
  public tipoSolucion!: TipoSolucion;

  @Prop({
    required: false,
    default: null,
  })
  public clavePrograma!: string;

  private consultandoBecas = false;

  /**
   * Controles de tabla de becarios
   */
  public totalBecarios = 0;
  public perPageBecarios = 25;
  public currentPageBecarios = 1;

  public filtroCvuBecarios: string | null = null;
  public filtroCurpBecario: string | null = null;
  public filtroNumeroApoyoBecario: string | null = null;
  public filtroNombreBecario: string | null = null;
  public filtroApellidoPaternoBecario: string | null = null;
  public filtroApellidoMaternoBecario: string | null = null;

  public becarios: Array<IBecaSeleccion> = [];
  public becariosSeleccionados: Array<IBecaSeleccion> = [];
  public readonly pageOptions: Array<number> = [5, 15, 25, 50, 100, 150];
  public readonly fieldsBecarios: BvTableFieldArray = [
    { key: 'checkedTabla', label: '' },
    {
      key: 'beca.numeroApoyo',
      label: this.$t('apeironGwApp.buscadorBecarios.campos.numeroApoyo').toString(),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'beca.becario.cvu',
      label: this.$t('apeironGwApp.buscadorBecarios.campos.cvu').toString(),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'beca.becario.nombre',
      label: this.$t('apeironGwApp.buscadorBecarios.campos.nombre').toString(),
      class: 'text-left',
      thStyle: { width: '20rem' },
    },
    {
      key: 'beca.becario.apellidoPaterno',
      label: this.$t('apeironGwApp.buscadorBecarios.campos.apellidoPaterno').toString(),
      class: 'text-left',
      thStyle: { width: '20rem' },
    },
    {
      key: 'beca.becario.apellidoMaterno',
      label: this.$t('apeironGwApp.buscadorBecarios.campos.apellidoMaterno').toString(),
      class: 'text-left',
      thStyle: { width: '20rem' },
    },
    {
      key: 'beca.becario.curp',
      label: this.$t('apeironGwApp.buscadorBecarios.campos.curp').toString(),
      class: 'text-left',
      thStyle: { width: '15rem' },
    },
    {
      key: 'beca.becario.genero',
      label: this.$t('apeironGwApp.buscadorBecarios.campos.genero').toString(),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'beca.programa.clave',
      label: this.$t('apeironGwApp.buscadorBecarios.campos.clavePrograma').toString(),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'beca.programa.nombre',
      label: this.$t('apeironGwApp.buscadorBecarios.campos.nombrePrograma').toString(),
      class: 'text-left horizontal-scroll-text',
      thStyle: { width: '30rem' },
    },
    {
      key: 'beca.programa.institucion.claveInstitucion',
      label: this.$t('apeironGwApp.buscadorBecarios.campos.claveInstitucion').toString(),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'beca.programa.institucion.nombreInstitucion',
      label: this.$t('apeironGwApp.buscadorBecarios.campos.nombreInstitucion').toString(),
      class: 'text-left horizontal-scroll-text',
      thStyle: { width: '30rem' },
    },
    {
      key: 'beca.periodoBeca.fechaInicioEstudios',
      label: this.$t('apeironGwApp.buscadorBecarios.campos.fechaInicioEstudios').toString(),
      class: 'text-left',
      thStyle: { width: '15rem' },
    },
    {
      key: 'beca.periodoBeca.fechaFinEstudios',
      label: this.$t('apeironGwApp.buscadorBecarios.campos.fechaFinEstudios').toString(),
      class: 'text-left',
      thStyle: { width: '15rem' },
    },
    {
      key: 'beca.periodoBeca.fechaInicioBeca',
      label: this.$t('apeironGwApp.buscadorBecarios.campos.fechaInicioBeca').toString(),
      class: 'text-left',
      thStyle: { width: '25rem' },
    },
    {
      key: 'beca.periodoBeca.fechaFinBeca',
      label: this.$t('apeironGwApp.buscadorBecarios.campos.fechaFinBeca').toString(),
      class: 'text-left horizontal-scroll-text',
      thStyle: { width: '15rem' },
    },
    {
      key: 'beca.periodoBeca.duracionBeca',
      label: this.$t('apeironGwApp.buscadorBecarios.campos.duracionBeca').toString(),
      class: 'text-left',
      thStyle: { width: '15rem' },
    },
    {
      key: 'beca.periodoBeca.duracionEstudios',
      label: this.$t('apeironGwApp.buscadorBecarios.campos.duracionEstudios').toString(),
      class: 'text-left',
      thStyle: { width: '15rem' },
    },
  ];

  public cambiarPagina(pagina: number) {
    this.currentPageBecarios = pagina;
    this.consultarBecas();
  }

  public buscarDesdePrimerPagina() {
    this.currentPageBecarios = 1;
    this.consultarBecas();
  }

  private consultarBecas(): void {
    this.consultandoBecas = true;
    this.becarios = [];
    this.becariosSeleccionados = [];
    this.totalBecarios = 0;

    const filtroConsultaBecas = new FiltroBeca();
    filtroConsultaBecas.tipoSolucion = this.tipoSolucion;
    filtroConsultaBecas.claveProgramaNacional = this.clavePrograma;
    filtroConsultaBecas.cvuBecarios = this.filtroCvuBecarios?.trim().split(',') ?? [];
    filtroConsultaBecas.nombreBecario = this.filtroNombreBecario;
    filtroConsultaBecas.apellidoPaternoBecario = this.filtroApellidoPaternoBecario;
    filtroConsultaBecas.apellidoMaternoBecario = this.filtroApellidoMaternoBecario;
    filtroConsultaBecas.curpBecario = this.filtroCurpBecario;
    filtroConsultaBecas.numeroApoyo = this.filtroNumeroApoyoBecario;

    const paginationQuery = {
      page: this.currentPageBecarios - 1,
      size: this.perPageBecarios,
      sort: ['numeroApoyo,desc'],
      filter: filtroConsultaBecas,
    };

    this.becaService()
      .retrieve(paginationQuery)
      .then(becas => {
        this.becarios = (becas.data ?? []).map(beca => new BecaSeleccion(false, beca));
        this.totalBecarios = Number(becas.headers['x-total-count']);
      })
      .catch(error => {
        if (!!error.response?.data?.detail) {
          this.alertService().showError(this, error.response.data.detail);
        } else {
          this.alertService().showHttpError(this, error.response);
        }
      })
      .finally(() => {
        this.consultandoBecas = false;
      });
  }

  public manejarSeleccionarTodas(): void {
    this.becariosSeleccionados = [];
    for (const becario of this.becarios) {
      this.manejarSeleccionarUna(becario);
    }
  }

  public manejarSeleccionarUna(becaSeleccion: IBecaSeleccion): void {
    const index = this.becariosSeleccionados.findIndex(
      row => !!row.beca?.id && !!becaSeleccion.beca?.id && row.beca?.id == becaSeleccion.beca?.id
    );
    if (index == -1) {
      this.becariosSeleccionados.push(becaSeleccion);
      becaSeleccion.checkedTabla = true;
    } else {
      this.becariosSeleccionados.splice(index, 1);
      becaSeleccion.checkedTabla = false;
    }
  }

  @Emit('selected')
  public emitirSeleccion(): Array<IBeca> {
    return this.becariosSeleccionados.map(beca => beca.beca).filter(beca => !!beca) ?? [];
  }

  get consultandoElBack(): boolean {
    return this.consultandoBecas;
  }
}
